const mapAdd = [

    {
        city: "Ahemdabad",
        link:"https://goo.gl/maps/22N1FhcGTkKcnhgQ8"
    },

    {
        city: "Amreli",
        link:"https://goo.gl/maps/sejSQtT5uwDUNsLw7"
    },

    {
        city: "Anand",
        link:"https://goo.gl/maps/CYHjdr5nGArtYjG98"
    },

    {
        city: "Aravalli",
        link:"https://goo.gl/maps/4sygv6gqtq4fwd3w8"
    },

    
    {
        city: "Banaskantha",
        link:"https://goo.gl/maps/kZ1zCixMQgHsUq848"
    },

    
    {
        city: "Bharuch",
        link:"https://goo.gl/maps/Ee4zzDujSLVWFBZC7"
    },

    
    {
        city: "Bhavnagar",
        link:"https://goo.gl/maps/DHv1UDwZKLyfkMpu8"
    },

    
    {
        city: "Botad",
        link:"https://goo.gl/maps/ddEGAwrJXD9jLmgg6"
    },

    
    {
        city: "Chota Udepur",
        link:"https://goo.gl/maps/vAuoUM42LoGsrYQQ6"
    },

    
    {
        city: "Dahod",
        link:"https://goo.gl/maps/DNPsWhKpMPFepsXP6"
    },

    
    
]



export default mapAdd;